@if (!hideButton) {
    <p *ngIf="label" class="text-dark">{{ label }}</p>
    <lib-button
        [hidden]="files && files.length > 0"
        fill="outline"
        (onClick)="onUploadButtonClick()"
        [displayAsInlineText]="buttonType === 'text'">
        <lib-svg-icon iconName="plus-thin" class="margin-right-small" [size]="18" />
        {{ buttonLabel }}
    </lib-button>
}

@if (!hideContent) {
    <div class="ion-margin-top">
        @for (file of files; track file.file?.name; let index = $index) {
            <div class="ion-margin-bottom">
                <lib-file-item
                    class="full-width"
                    [button]="true"
                    [file]="file"
                    [displayFileSize]="false"
                    [displayExpiration]="true"
                    [displayFileType]="showDocumentTypeSelector"
                    [expirationDate]="file.expiration_year"
                    (onItemClick)="showModal(file, index)"
                    (onRemoveClick)="onFileRemove(index)" />
            </div>
        }
    </div>
}

@if (!hideButton) {
    <div class="ion-margin-top">
        <lib-button
            [hidden]="!files || !files.length || files.length >= maxFiles"
            [displayAsInlineText]="true"
            fill="outline"
            borderStyle="none"
            [expand]="false"
            (onClick)="onUploadButtonClick()">
            <lib-svg-icon iconName="plus-thin" class="margin-right-small" [size]="18" />
            {{ additionalButtonLabel }}
        </lib-button>
    </div>
}

<input
    (change)="selectFileChangeOnInput($event)"
    #fileInput
    type="file"
    class="file-input hidden"
    [accept]="acceptFileFormats.join(',')" />

<image-cropper
    class="hidden-visually-important"
    #imageCropper
    [autoCrop]="true"
    [resizeToWidth]="1000"
    [resizeToHeight]="1000"
    [onlyScaleDown]="true"
    [imageQuality]="80"
    output="base64"
    [imageBase64]="base64Image() || undefined"
    (imageCropped)="onImageCrop($event)"
    (loadImageFailed)="onImageLoadFail()" />

@if (mobileActionSheetButtons().length) {
    <lib-action-sheet
        #mobileActionSheet
        [buttons]="mobileActionSheetButtons()"
        (onActionClick)="onActionSheetClick($event)"
        (onDidDismiss)="onActionSheetDidDismiss($event)" />
}

<ion-modal #documentModal class="modal-window" [keepContentsMounted]="true">
    <ng-template>
        <div class="ion-padding">
            <h3 class="text-center" *ngIf="modalTitle">{{ modalTitle }}</h3>

            <div [hidden]="modalBase64">
                <ion-button
                    fill="none"
                    class="full-width border-dashed border-radius button-unstyled"
                    [style.--ripple-color]="'var(--ion-color-orange)'"
                    (click)="selectFile()"
                    [disabled]="isLoadingDocument()">
                    @if (isLoadingDocument()) {
                        <div class="ion-text-center ion-margin-vertical">
                            <ion-spinner />
                        </div>
                    } @else {
                        <div class="full-width ion-text-center ion-padding-top">
                            <div class="flex justify-content-center">
                                <lib-svg-icon
                                    iconName="plus-thin"
                                    [size]="16"
                                    borderColor="var(--ion-color-orange)"
                                    [borderSpacing]="15"
                                    [roundBorder]="true"
                                    color="var(--ion-color-orange)" />
                            </div>
                            <div class="ion-margin-vertical">
                                <p class="text-midsmall text-transform-none ion-no-margin">
                                    (Max file size: {{ maxFileSizeMb }} MB)
                                </p>
                                @if (acceptFileFormats.length) {
                                    <p class="text-midsmall text-transform-none ion-no-margin">
                                        Accepted file formats: {{ acceptFileFormats.join(', ') }}
                                    </p>
                                }
                            </div>
                        </div>
                    }

                    <div class="ion-activatable full-width full-height position-absolute-center">
                        <ion-ripple-effect></ion-ripple-effect>
                    </div>
                </ion-button>
            </div>

            @if (isLoadingDocument() && modalBase64) {
                <div class="ion-text-center">
                    <ion-spinner />
                </div>
            }

            @if (!isLoadingDocument()) {
                <lib-file-item
                    [file]="{
                        base64: modalBase64,
                        expiration_year: modalYear,
                        expiration_month: modalMonth,
                        name: modalFileName || '',
                        size: modalFileSize || undefined
                    }"
                    (onRemoveClick)="removeModalFile()" />
            }

            @if (showDocumentTypeSelector) {
                <div class="ion-margin-top">
                    <lib-select
                        (selectChange)="onDocumentTypeSelect($event)"
                        [options]="documentTypeOptions"
                        label="Document type"
                        [ionItemWrap]="false"
                        [value]="modalDocumentType" />
                </div>
            }

            @if (showExpirationInputs) {
                <p class="text-dark ion-no-margin ion-margin-top">Document expiration date</p>

                <div class="flex align-items-center">
                    <lib-select
                        (selectChange)="onSelectChange($event, 'month')"
                        class="full-width margin-right-small"
                        [ionItemWrap]="false"
                        [options]="monthOptions"
                        placeholder="Month"
                        [value]="modalMonth" />
                    <lib-select
                        (selectChange)="onSelectChange($event, 'year')"
                        class="full-width margin-left-small"
                        [ionItemWrap]="false"
                        placeholder="Year"
                        [options]="yearOptions"
                        [value]="modalYear" />
                </div>
            }

            <div class="ion-margin-bottom" [ngClass]="{ 'ion-margin-top': !showExpirationInputs }">
                <lib-button
                    [disabled]="
                        isLoadingDocument() ||
                        (showExpirationInputs && (!modalBase64 || !modalYear || !modalMonth)) ||
                        (!showExpirationInputs && !modalBase64)
                    "
                    (onClick)="addDocument()">
                    @if (modalFileIndex() === null || modalFileIndex() === undefined) {
                        Add
                    } @else {
                        Edit
                    }
                    document
                </lib-button>
            </div>
            <lib-button [disabled]="isLoadingDocument()" (onClick)="onCancelClick()" fill="outline">Cancel</lib-button>
        </div>
    </ng-template>
</ion-modal>
